var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","scrollable":"","width":"900"},model:{value:(_vm.shown),callback:function ($$v) {_vm.shown=$$v},expression:"shown"}},[(!_vm.welcomePassed)?_c('Welcome',{on:{"next":_vm.openCompanyQuiz}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }